module.exports = __webpack_public_path__ + "static/team-88f665688e956885d9a6f83ed437ec67.png";